import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-73" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "0px"
    }} data-id="element-74" data-mp="4lqj4w64bd3i">
        

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Poppins, sans-serif",
        fontSize: "19px",
        color: "#6E3CC4",
        fontWeight: "800"
      }} data-id="element-75" data-mp="12a0j75mcfqrz">
          Stop Nagging. Start Guiding. The Visual System that teaches your child to get ready alone
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "10px",
        paddingBottom: "20px",
        color: "#232C43",
        fontSize: "10px"
      }} data-id="element-76" data-mp="nbyh6zuyndcu">
          Finally, enjoy your morning coffee in peace. No more shouting and zero chaos. Just a calm, independent child who knows exactly what to do next.
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-3xl" data-id="element-77" data-mp="3o6kd5bieo01y">
          <img src="https://cdn.magicpatterns.com/uploads/bCXm8ZH3iYAviNqPuk6mPG/ChatGPT_Image_23_sept_2026,_12_37_59.png" alt="The Autonomous Child Visual System — eBook, visual routine app and printable routine cards" width={1672} height={941} className="animate-floaty mx-auto aspect-[1672/941] w-full max-w-full rounded-2xl object-cover shadow-[0_24px_50px_-28px_rgba(7,35,26,0.45)]" data-id="element-78" data-mp="30hrf99i83i4p" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-79" data-mp="2hk85g3nxxvh8">
          ⭐ 4.9 (+500 families using visual routines) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-80" data-mp="na08qxnyt1dn">
          <CTAButton href="#value" data-id="element-81" data-mp="ibgmsx9dfpla">See the system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-82" data-mp="i9vuleaj4iql">
            THE AUTONOMOUS CHILD VISUAL SYSTEM™ helps you organize morning, afternoon and bedtime
            activities so that each step of the day can be seen clearly and understood by your
            child.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-83" data-mp="112g3zcamjv40">
            One thing at a time · Fully customizable · <span className="text-blush" data-id="element-84" data-mp="3hrlosum1wtes">No monthly subscription</span>
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-85" data-mp="1x9ku2l5yd2go">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-86" data-mp="21bfu7mc5d9sv">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-87" data-mp="2b0zi56epvtul" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-88" data-mp="2fz0znmwhvl3y">
            eBook + 5 bonuses · Morning · Afternoon · Night.
          </p>
        </div>

        

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-89" data-mp="2ozz589ml00on">
          🔥 Limited-time offer · Then the price goes back up to $38
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-90" data-mp="3vhxhrntqxg0n">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-91" data-mp="ea3g9d1qq26z" />
          25 families are looking at this product right now
        </p>
      </div>
    </header>;
}